import styled from "@emotion/styled";
import { Row, Col } from "antd";

export const SignUpContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  width: 1200px;
  margin: ${(props) => props.theme.spacing.md} auto
    ${(props) => props.theme.spacing.md} auto;
  padding: ${(props) => props.theme.spacing.md};

  @media (min-width: 768px) {
    min-width: 376px;
  }
`;

export const DeleteCol = styled(Col)`
  margin-right: ${(props) => props.theme.spacing.regular};
`;

export const RPContainer = styled.div`
  background-color: ${(props) => props.theme.color.secondary};
  border: none;
  border-radius: 5px 0 0 5px;
  box-shadow: 0 2px 2px ${(props) => props.theme.color.primary}33;
  margin-left: ${(props) => props.theme.spacing.regular};
  padding: ${(props) => props.theme.spacing.regular} !important;
  padding-bottom: ${(props) => props.theme.spacing.xxs} !important;
  ${(props) => props.isSticky && "position: fixed"};
  width: auto;
`;

export const RPTitle = styled(Row)`
  color: ${(props) => props.theme.color.primary};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  font-size: 16px;
`;

export const RPDesc = styled(Row)`
  color: ${(props) => props.theme.color.primary};
  font-size: 14px;
  line-height: normal;
  padding-top: ${(props) => props.theme.spacing.xs} !important;
`;

export const RPRequirement = styled(Row)`
  color: ${(props) => props.theme.color.primary};
  font-weight: ${(props) => props.theme.fontWeight.bold};
  font-size: 14px;
  line-height: normal;
  padding-top: ${(props) => props.theme.spacing.xs} !important;
  padding-bottom: ${(props) => props.theme.spacing.xs} !important;
`;
